import React from 'react';
import {Text} from 'react-native';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import Checkbox from '../Checkbox';

export default () => (
  <>
    <Heading level={1}>Checked State</Heading>
    <Spacer size={16} />
    <Text>
      The checked state of the <Code>Checkbox</Code> component is controlled via
      the <Code>checked</Code> prop.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center" expand={false}>
        <Checkbox checked={true} />
        <Spacer size={6} />
        <Code>{'checked={true}'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center" expand={false}>
        <Checkbox checked={false} />
        <Spacer size={6} />
        <Code>{'checked={false}'}</Code>
      </FlexView>
    </FlexView>
  </>
);
